export enum BehaviorProfileStatus {
  UNSELECTED,
  SELECTED,
  PARTIAL,
}

export interface BehaviorProfileListItem {
  id: string;
  name: string;
  status: BehaviorProfileStatus;
  parentId?: string;
  departmentId?: string;
  totalProfiles?: number;
  totalRestrictedProfiles?: number;
}

export interface BehaviorProfilesOutput {
  departments: { [id: string]: BehaviorProfileStatus }[];
  users: { [id: string]: BehaviorProfileStatus }[];
  profiles: { [id: string]: BehaviorProfileStatus }[];
}
